import React from 'react';
import { Row, Col, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import {
  FacebookOutlined,
  YoutubeOutlined,
  InstagramOutlined,
  LinkedinOutlined,
} from '@ant-design/icons';

const { Text, Title } = Typography;

const companyLinks = [
  { label: 'Company', path: '/about-us' },
  { label: 'Contact', path: '/contact' },
  { label: 'Privacy', path: '/privacy' },
  { label: 'Terms & Conditions', path: '/terms-and-conditions' },
  { label: 'Cookie Policy', path: '/cookie-policy' },
];

const socialIcons = [
  { icon: <FacebookOutlined />, link: 'https://facebook.com/yallanellab', label: 'Facebook' },
  { icon: <YoutubeOutlined />, link: 'https://youtube.com/yallanellab', label: 'YouTube' },
  { icon: <span style={{ fontFamily: 'sans-serif', fontWeight: 'bold' }}>X</span>, link: 'https://x.com/yallanellab', label: 'X (Twitter)' },
  { icon: <InstagramOutlined />, link: 'https://instagram.com/yno.ae ', label: 'Instagram' },
  { icon: <LinkedinOutlined />, link: 'https://linkedin.com/company/yallanellab', label: 'LinkedIn' },
];

const Footer = () => {
  const footerStyle = {
    backgroundColor: '#FFFFFF',
    padding: '40px 50px 20px',
    marginTop: '60px',
    borderTop: '1px solid #E6E6E6',
  };

  const linkStyle = {
    color: '#595959',
    fontSize: '15px',
    textDecoration: 'none',
    display: 'block',
    marginBottom: '8px',
  };

  const socialIconStyle = {
    fontSize: '24px',
    color: '#000000',
    margin: '0 10px',
  };

  const newsletterButtonStyle = {
    backgroundColor: '#E53E3E',
    borderColor: '#E53E3E',
    borderRadius: '0px',
    color: '#FFFFFF',
    fontWeight: 'bold',
    width: '40%',
    marginTop: '10px',
    padding: '10px 15px',
    height: 'auto',
  };

  // ✅ CSS for responsive behavior
  const responsiveStyle = `
    @media (max-width: 768px) {
      .footer-row {
        display: flex;
        flex-direction: column;
      }

      .footer-newsletter {
        order: 1;
      }

      .footer-company-col {
        order: 2;
        text-align: left !important;
        margin-top: 20px;
      }

      .footer-social {
        order: 3;
        text-align: left !important;
        margin-top: 10px !important;
      }

      .footer-bottom {
        order: 4;
        margin-top: 30px !important;
        text-align: center !important;
      }
    }
  `;

  return (
    <div style={footerStyle}>
      <style>{responsiveStyle}</style>

      <Row gutter={[32, 32]} justify="space-between" align="top" className="footer-row">
        {/* --- Left Column: Newsletter --- */}
        <Col xs={24} md={8} lg={6} className="footer-newsletter">
          <Title level={5} style={{ color: '#000000', marginBottom: '10px' }}>
            NEWSLETTER SIGN UP
          </Title>
          <Text style={{ display: 'block', fontSize: '13px', color: '#595959', marginBottom: '15px' }}>
            Never miss an update from YNO
          </Text>
          <Button type="primary" size="large" style={newsletterButtonStyle}>
            SIGN UP
          </Button>

        </Col>

        {/* --- Center Column (Social Icons) --- */}
        <Col xs={24} md={8} lg={8} className="footer-social" style={{ textAlign: 'center' }}>
          <Title level={5} style={{ color: '#000000', marginBottom: '20px' }}>
            Follow Us On
          </Title>
          <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
            {socialIcons.map((social, index) => (
              <Link
                key={index}
                to={social.link}
                aria-label={social.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span style={socialIconStyle}>{social.icon}</span>
              </Link>
            ))}
          </div>
        </Col>

        {/* --- Right Column (Company Links) --- */}
        <Col xs={24} md={8} lg={6} className="footer-company-col" style={{ textAlign: 'right' }}>
          {companyLinks.map((link) => (
            <Link key={link.label} to={link.path} style={{ ...linkStyle, fontSize: '14px' }}>
              {link.label}
            </Link>
          ))}
        </Col>
      </Row>

      {/* --- Bottom Center Copyright --- */}
      <Row justify="center" className="footer-bottom" style={{ marginTop: '40px' }}>
        <Col xs={24}>
          <Text
            type="secondary"
            style={{
              display: 'block',
              textAlign: 'center',
              fontSize: '13px',
              color: '#595959',
            }}
          >
            &copy; {new Date().getFullYear()} Yalla Nellab. All Rights Reserved.
          </Text>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
